<template>
  <div class="home"
  data-aos="fade-left"
  data-aos-easing="ease-out-quad"
  data-aos-duration="250">
    <div class="home-intro">
      <div class="potrait">
        <img src="../assets/headshots/FullSizeRender.jpg" alt="Haider Ahmed posing in Time Square, New York" >
      </div>
      <div class="text-intro">

        <h1>Haider Ahmed</h1>
        <p class="sub-heading">Software Developer</p>
        <hr>

        A forward-thinking developer that is passionate about Software Development, Cloud Computing and Computer Vision. Currently working on projects that are using LAMP and MERN stack.
        
        <p> 
          <b class="color-secondary">Current</b><br />
           Full Stack Developer - Rogers Communications<br /><br/>
           <b class="color-secondary">Past Experience</b><br />
           Full Stack Developer - Loblaw Companies Limited<br />
           Software Developer, RBC Amplify <br />
           Innovation Strategy Analyst, Sun Life Financial <br />
           Web Developer, IBM Watson Analytics<br />
           Front End Developer, IBM Watson Analytics<br />
           Business Technology Analyst, Eli Lilly Canada 
        </p>

        <p> <b class="color-secondary">Certifications</b><br />
            GCP Cloud Associate Engineer - <a href="https://www.credential.net/c6020ee0-ed05-4911-984c-671562c40b69" target="_blank"> View Credentails</a> <br />
            Azure Fundamental (AZ-900) - <a href="https://www.youracclaim.com/badges/2f320ce4-b88a-441e-a7df-dbde7deec5a7?source=linked_in_profile" target="_blank">View Credentails</a><br />
        </p>

        <!-- <p> <b class="color-secondary">Hackathons</b><br />
            QHacks 2018 - Scotia Bank ML/AI Prize<br />
            RBC NGI Hackathon 2017 Winner<br />
        </p> -->

        <p class="social"> <a href="https://www.linkedin.com/in/haiderahmed/" target="_blank"><i class="fab fa-linkedin"></i></a>  <a href="mailto:haider.ahmed@ryerson.ca" target="_blank"><i class="far fa-envelope"></i></a></p>
      
      </div>
    </div>
  </div>
</template>

<script>
import AOS from 'aos';

// @ is an alias to /src

import Jobs from '@/components/jobs.vue'


AOS.init();
export default {
  name: 'home',
  components: {
    Jobs
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width:700px) {
  .home {
    padding: 20px 0 50px 0;
  }
}

.home-intro {
  min-height: 100vh;
  display: flex;
  align-items: center;


 .potrait {
   width: 50%;
 }

 .text-intro{
   width: 100%;
   padding: 50px;
   text-align: left;
   display: flex;
   justify-content: center;
   flex-direction: column;

   h1 {
    margin: 0px;
   }

   .sub-heading {
     text-align: center;
     margin-bottom: 0;
   }



   i {
     font-size: 20px;
     padding: 5px;
     color: black;
   }

   .social{
     text-align:center;
   }

   h1 {
     text-align: center;
     font-family: 'Quicksand', sans-serif;
     font-weight: bold;
   }
 }


}

@media only screen and (max-width: 900px) {
  .home-intro {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

   .potrait {
     width: 80%;
     img {
       width: 100%;
       margin: 30px 0;
     }
   }

   .text-intro{
     padding: 0;
     width: 100%;
     text-align: left;
     display: flex;
     flex-direction: column;

     justify-content: center;
   }

   .btn-primary{
     display: none;
   }
  }
}

</style>
